import { render, staticRenderFns } from "./Requests.vue?vue&type=template&id=26138b61&scoped=true"
import script from "./Requests.vue?vue&type=script&lang=ts"
export * from "./Requests.vue?vue&type=script&lang=ts"
import style0 from "./Requests.vue?vue&type=style&index=0&id=26138b61&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26138b61",
  null
  
)

export default component.exports